// extracted by mini-css-extract-plugin
module.exports = {"inputClass":"index_inputClass__1C3Fh"};